module.exports = __webpack_public_path__ + "img/menu-bar_01.3c746f4c.png";